//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { rinkoPolicyQuery, applicationNoDelete } from '@/api/rinko';
import { getChilComList, getProductList, getCompanyList } from '@/api/baseDate';
export default {
  name: 'InsurancePolicySearch',
  data: function data() {
    return {
      currentPage4: 4,
      loading: true,
      restaurants: [],
      timeout: null,
      tableData: [],
      options2: [],
      options: [],
      inForm: {
        // 保险公司
        insuranceCompanyCode: '',
        // 投保公司
        insureCompanyCode: '',
        // 投保单申请号
        applicationNo: '',
        // 申请日期起
        startDate: '',
        // 申请日期止
        endDate: '',
        // 状态
        applicationStatus: '',
        customCompanyName: '',
        user_type: '',
        // 状态
        options: [{
          value: '1',
          label: '暂存'
        }, {
          value: '2',
          label: '提交'
        }]
      },
      pageNo: 1,
      // 第几页
      pageSize: 10,
      // 每页数量
      total: 0,
      // 总条数
      rules: {
        insuranceCompanyCode: [{
          required: false,
          message: '请选择保险公司',
          trigger: 'change'
        }],
        insureCompanyCode: [{
          required: false,
          message: '请选择投保公司',
          trigger: 'change'
        }]
      },
      // 机构
      options_insuranceCompanyName: [{
        value: 'IC0030',
        label: '中国太平洋财产保险股份有限公司上海分公司'
      }],
      options_insureCompanyName: [],
      options_companyName: [],
      options_proposalStatus: []
    };
  },
  watch: {
    '$route': 'getPath' // 当路由发生变化时执行此函数

  },
  mounted: function mounted() {},
  created: function created() {
    this.Init_get();
    console.log('页面protocol-search.vue');
    var list = this.$store.state.user.userinfo.insuranceCompanyList || [];
    var companyCode = this.$store.state.user.userinfo.insuranceCompanyCode || '';
    this.get_select(list, companyCode); // 默认第一个保险公司

    this.inForm.insuranceCompanyCode = this.options_insuranceCompanyName[0].value || '';
    this.inForm.insuranceCompanyName = this.options_insuranceCompanyName[0].label || '';
    this.restaurants = this.loadAll();
  },
  methods: {
    getPath: function getPath() {
      this.Init_get();
    },
    // 初始化
    Init_get: function Init_get() {
      var _this = this;

      var data = this.inForm;
      this.loading = true;
      data.insuranceCompanyName = this.inForm.insuranceCompanyName;
      data.insuranceCompanyCode = this.inForm.insuranceCompanyCode;
      data.insureCompanyCode = this.inForm.insureCompanyCode;
      data.insureCompanyName = this.inForm.insureCompanyName;
      data.applicationNo = this.inForm.applicationNo;
      data.applicationStatus = this.inForm.applicationStatus;
      data.startDate = this.inForm.startDate;
      data.endDate = this.inForm.endDate;
      data.pageNo = this.pageNo;
      data.pageSize = this.pageSize;
      rinkoPolicyQuery(data).then(function (res) {
        var orgCode = JSON.parse(sessionStorage.getItem('neworgCode'));

        if (res.content != null) {
          for (var i = 0; i < res.content.length; i++) {
            // if (res.content[i].identifyNumber != null) {
            //   res.content[i].user_type = '0'
            //   if (orgCode == res.content[i].identifyNumber) {
            //     console.log(res.content[i].identifyNumber, i)
            //     res.content[i].user_type = '1'
            //   }
            // }
            if (orgCode != '' || orgCode != null) {
              res.content[i].user_type = '0';

              if (orgCode == res.content[i].identifyNumber) {
                res.content[i].user_type = '1';
              }
            } else {
              res.content[i].user_type = '1';
            }
          }
        }

        _this.tableData = res.content;
        _this.total = res.totalCount;
        _this.loading = false;
      });
    },
    // 保险公司
    insuranceCompanyCode_ch: function insuranceCompanyCode_ch(val) {
      var obj = {};
      obj = this.options_insuranceCompanyName.find(function (item) {
        // 这里的userList就是上面遍历的数据源
        return item.value === val; // 筛选出匹配数据
      });
      this.inForm.insuranceCompanyName = obj.label; // 查询保险公司下的分支机构

      this.companyqueryAll_fun(val);
      this.riskqueryAll_fun(val);
    },
    insureCompanyCode_ch: function insureCompanyCode_ch() {},
    // 每页条数
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.Init_get();
    },
    // 当前页码
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.Init_get();
    },
    // 查询
    search_s: function search_s(formName) {
      var _this2 = this;

      // var data = {}
      //  去除首尾空格
      // 投保意向申请单号
      this.inForm.applicationNo = this.inForm.applicationNo.trim(); // 起期

      this.inForm.startDate = this.inForm.startDate.trim(); // 止期

      this.inForm.endDate = this.inForm.endDate.trim(); // 状态

      this.inForm.applicationStatus = this.inForm.applicationStatus.trim();

      if (this.inForm.startDate && this.inForm.endDate) {
        if (this.inForm.startDate > this.inForm.endDate) {
          this.$message({
            type: 'warning',
            message: '起保起期不能晚于起保止期'
          });
          return false;
        } else {
          this.$refs[formName].validate(function (valid) {
            if (valid) {
              _this2.pageNo = 1;

              _this2.Init_get();
            } else {
              return false;
            }
          });
        }
      } else {
        this.$refs[formName].validate(function (valid) {
          if (valid) {
            _this2.pageNo = 1;

            _this2.Init_get();
          } else {
            return false;
          }
        });
      }
    },
    // 重置
    search_s_clear: function search_s_clear() {
      this.inForm = {
        // 保险公司
        insuranceCompanyCode: '',
        insuranceCompanyName: '',
        // 投保公司
        insureCompanyCode: '',
        insureCompanyName: '',
        // 投保单申请号
        applicationNo: '',
        // 申请日期起
        startDate: '',
        // 申请日期止
        endDate: '',
        // 状态
        applicationStatus: ''
      };
      this.insuranceCompanyCode_ch(this.inForm.insuranceCompanyCode);
    },
    // 支持模糊查询
    loadAll: function loadAll() {
      return [{
        'value': '三全鲜食（北新泾店）',
        'address': '长宁区新渔路144号'
      }, {
        'value': 'Hot honey 首尔炸鸡（仙霞路）',
        'address': '上海市长宁区淞虹路661号'
      }, {
        'value': '新旺角茶餐厅',
        'address': '上海市普陀区真北路988号创邑金沙谷6号楼113'
      }];
    },
    // ------下拉信息
    get_select: function get_select(list, code) {
      this.findInsuranceCompany_fun(list);
      this.companyqueryAll_fun(code);
    },
    // 保险公司
    findInsuranceCompany_fun: function findInsuranceCompany_fun(list) {
      var _this3 = this;

      this.options_insuranceCompanyName = [];

      for (var i = 0; i < list.length; i++) {
        var obj = {};
        obj.value = list[i].insuranceCompanyCode;
        obj.label = list[i].insuranceCompanyName;

        if (!obj.value || !obj.label) {
          this.options_insuranceCompanyName = [];
        } else {
          this.options_insuranceCompanyName.push(obj);
        }
      }

      var data = {
        insuranceCompanyCode: code
      };
      getCompanyList(data).then(function (res) {
        _this3.options_insuranceCompanyName = [];

        for (var i = 0; i < res.length; i++) {
          console.log(res);
          var obj = {};
          obj.value = res[i].insuranceCompanyCode;
          obj.label = res[i].insuranceCompanyName;

          if (!obj.value || !obj.label) {
            _this3.options_insuranceCompanyName = [];
          } else {
            _this3.options_insuranceCompanyName.push(obj);
          }
        }
      });
    },
    // 查看
    view_but: function view_but(type, data) {
      console.log(data);
      var params = {
        type: type,
        applicationNo: data.row.applicationNo
      };

      if (type == 'view') {
        this.$router.push({
          path: "/rinkoPlatInsurance/insuranceApplyFor/".concat(params.type, "/").concat(params.applicationNo)
        });
      } else {
        this.$router.push({
          path: "/rinkoPlatInsurance/insuranceApplyForUpdate/".concat(params.type, "/").concat(params.applicationNo)
        });
      }
    },
    // 删除
    dele: function dele(data) {
      var _this4 = this;

      this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        debugger;
        applicationNoDelete({
          applicationNo: data.applicationNo
        }).then(function (res) {
          // console.log(res)
          if (res.resultCode == '0000') {
            _this4.$message({
              type: 'success',
              message: '删除成功!'
            });

            _this4.getData();
          } else {
            _this4.$message({
              type: 'warning',
              message: res.resultMsg
            });
          }
        });
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 转为有效保单
    transfer_validPolicy: function transfer_validPolicy(applicationNo) {
      // 跳转
      this.$router.push({
        path: '/rinkoPlatPolicyManage/policyInfoBuLu?applicationNo=' + applicationNo
      });
    },
    // 产品名称
    riskqueryAll_fun: function riskqueryAll_fun(code) {
      var _this5 = this;

      this.options2 = [];
      var data = {
        insuranceCompanyCode: code
      };
      getProductList(data).then(function (res) {
        _this5.options2 = [];

        for (var i = 0; i < res.length; i++) {
          var obj = {};
          obj.value = res[i].riskCode;
          obj.label = res[i].riskName;

          _this5.options2.push(obj);
        }

        console.log(_this5.options2);
      });
    },
    // 分支机构
    companyqueryAll_fun: function companyqueryAll_fun(code) {
      var _this6 = this;

      this.options_companyName = [];
      var data = {
        insuranceCompanyCode: code
      };
      getChilComList(data).then(function (res) {
        for (var i = 0; i < res.length; i++) {
          var obj = {};
          obj.value = res[i].companyCode;
          obj.label = res[i].companyName;

          _this6.options_companyName.push(obj);
        }
      });
    },
    download: function download(self, data) {
      console.log(data.policyUrl);
      window.open(data.policyUrl);
    }
  }
};